import { render, staticRenderFns } from "./RelatedProducts.vue?vue&type=template&id=7ba0a9a2&scoped=true&"
import script from "./RelatedProducts.vue?vue&type=script&lang=ts&"
export * from "./RelatedProducts.vue?vue&type=script&lang=ts&"
import style0 from "./RelatedProducts.vue?vue&type=style&index=0&id=7ba0a9a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ba0a9a2",
  null
  
)

export default component.exports